import { apiRequest } from "./apiClient";

export const adminService = {
  async getSolicitations() {
    return apiRequest("/admin/solicitations", {
      method: "GET",
    });
  },

  async createQuotation({ requestId, amount, description }) {
    return apiRequest(`/admin/solicitations/${requestId}/quotation`, {
      method: "POST",
      body: JSON.stringify({ amount, description }),
    });
  },

  async updateStatus({ id, status }) {
    return apiRequest(`/admin/solicitations/${id}/status`, {
      method: "POST",
      body: JSON.stringify({ status }),
    });
  },

  async getQuotations({ id }) {
    return apiRequest(`/admin/solicitations/${id}/quotations`, {
      method: "GET",
    });
  },
};
